import isUrl from 'is-url';

const urlProp = (props, prop, component) =>
  !isUrl(props[prop]) ? new Error(`Invalid prop ${prop} supplied to ${component}. Must be a valid URL.`) : null;

export { urlProp };
